/* eslint-disable  @typescript-eslint/camelcase */
import { useMutation } from '@apollo/react-hooks'
import CreatePayment from './graphql/CreatePaymentIntent.graphql'
import ConfirmPayment from './graphql/ConfirmPaymentIntent.graphql'
import { stripeStatus } from '../Constants'
import CustomError from '../lib/CustomError'

const LOADER_STATUS = {
  CREATE_PAYMENT_METHOD: 1,
  CREATE_PAYMENT_INTENT: 2,
  CONFIRM_PAYMENT_INTENT: 3,
}

function usePaymentHandler(
  setOrderId: (args: string) => void,
  setLoaderStatus: (args?: number) => void = () => {},
) {
  const [createPaymentIntent] = useMutation(CreatePayment)
  const [confirmPaymentIntent] = useMutation(ConfirmPayment)

  const paymentHandler = async (input, stripe) => {
    setTimeout(() => {
      setLoaderStatus(LOADER_STATUS.CREATE_PAYMENT_METHOD)
    }, 1000)
    /** create payment intent */
    const createPaymentResult = await createPaymentIntent({
      variables: { input },
    })

    setLoaderStatus(LOADER_STATUS.CREATE_PAYMENT_INTENT)
    const createPaymentData = createPaymentResult?.data?.createPayment

    /** handle error on creation */
    if (createPaymentData?.errors?.length) {
      throw new CustomError(
        createPaymentData?.errors[0]?.code,
        createPaymentData?.errors[0]?.message,
      )
    }

    /** pass the orderId to the state */
    if (typeof setOrderId === 'function') {
      setOrderId(createPaymentData?.orderId)
    }

    const paymentIntentStatus = createPaymentData?.paymentIntent?.status

    if (paymentIntentStatus === stripeStatus.REQUIRES_ACTION) {
      const clientSecret = createPaymentData?.paymentIntent?.client_secret
      await stripe.handleCardAction(clientSecret)
    }

    const confirmPaymentResult = await confirmPaymentIntent({
      variables: {
        input: {
          paymentIntentId: createPaymentData?.paymentIntent.id,
          orderId: createPaymentData?.orderId,
          productId: input?.orderDetails?.productId,
          variant_id: input?.orderDetails?.variant_id,
        },
      },
    })

    const confirmPaymentData = confirmPaymentResult?.data?.confirmPayment

    /** handle error on confirmation */
    if (confirmPaymentData?.errors?.length) {
      throw new CustomError(
        createPaymentData?.errors[0]?.code,
        createPaymentData?.errors[0]?.message,
      )
    }
    setLoaderStatus(LOADER_STATUS.CONFIRM_PAYMENT_INTENT)

    if (typeof setOrderId === 'function') {
      setOrderId(confirmPaymentData?.orderName)
    }
    return {
      status: confirmPaymentData?.paymentIntent?.status,
      orderId: createPaymentData?.orderId,
      orderName: confirmPaymentData?.orderName,
    }
  }

  return [paymentHandler]
}

export default usePaymentHandler
